<div class="row">
  <div class="col-12">
    <now-wbsuche-lib-detail-kachel
      [icon]="'now-icon-notebook'"
      [id]="'inhalte'"
      [title]="'Weiterbildungsinhalte'"
      [collapseButtonText]="'zu den Weiterbildungsinhalten'"
      [ausklappbar]="inhalteAusklappbar"
      [anreisser]="inhaltText"
      [collapsed]="inhalteEingeklappt"
      (collapsedChanged)="collapseStates.weiterbildungsinhalte = $event"
    >
      <now-wbsuche-lib-weiterbildungsinhalte
        [termin]="termin"
      ></now-wbsuche-lib-weiterbildungsinhalte
    ></now-wbsuche-lib-detail-kachel>

    @if (showZugangsinformationen) {
      <now-wbsuche-lib-detail-kachel
        [icon]="'now-icon-door-open'"
        [id]="'zugang'"
        [title]="'Zugangsinformationen'"
        [collapseButtonText]="'zu den Zugangsinformationen'"
        [ausklappbar]="zugangAusklappbar"
        [anreisser]="zugangText"
        [collapsed]="zugangEingeklappt"
        (collapsedChanged)="collapseStates.zugang = $event"
        ><now-wbsuche-lib-zugangsinformationen
          [termin]="termin"
        ></now-wbsuche-lib-zugangsinformationen
      ></now-wbsuche-lib-detail-kachel>
    }
    <now-wbsuche-lib-detail-kachel
      [id]="'weiterbildungsinfo'"
      [title]="'Weiterbildungs&shy;informationen'"
      [icon]="'now-icon-graduation-cap'"
      [collapseButtonText]="'zu den Weiterbildungsinformationen'"
      ><now-wbsuche-lib-weiterbildungsinformationen
        [termin]="termin"
      ></now-wbsuche-lib-weiterbildungsinformationen
    ></now-wbsuche-lib-detail-kachel>
  </div>
</div>
